import { MutationObserverOptions, useMutation } from 'react-query';
import { postConfirmBankingOrder } from '../../apis/tms/order.api';
import { IConfirmBankingRequest } from '../../interfaces/order.interface';

const useConfirmBanking = ({
  opt,
}: {
  opt?: Omit<
    MutationObserverOptions<string, Error, IConfirmBankingRequest, string>,
    '_defaulted' | 'variables'
  >;
}) => {
  const mutationReturn = useMutation({
    ...opt,
    mutationFn: postConfirmBankingOrder,
  });

  return { mutationReturn };
};

export default useConfirmBanking;
